import type { OsResourceReadV2Api } from '@ingenico/api-sdk-device-management-private-v2';
import { toArray, toString } from 'lodash-es';
import type {
  ContentDetailsDTO,
  OsVersionPublicationStatus,
} from '../../../../pages/os-application-details-page/OSApplicationDetailsPage.model';

export function mapOsById({
  compatibleDeviceFamilyNames,
  creationDate: payloadCreationDate,
  id,
  longDescription,
  name,
  osVersionIds,
  publisherId,
  shortDescription,
  status: payloadStatus,
}: OsResourceReadV2Api): Omit<ContentDetailsDTO, 'latestVersion' | 'markdown' | 'OSVersion' | 'publicationDate'> {
  const title = toString(name);
  const label = payloadStatus?.toLowerCase() ?? 'deprecated';
  const type = payloadStatus?.toLowerCase() ?? 'deprecated';
  const deviceFamilies = toArray(compatibleDeviceFamilyNames);

  return {
    title,
    status: {
      label,
      type,
    },
    shortDescription: toString(shortDescription),
    longDescription: toString(longDescription),
    deviceFamilies,
    creationDate: payloadCreationDate ?? '',
    getByIdPayload: {
      compatibleDeviceFamilyNames,
      creationDate: payloadCreationDate,
      id,
      longDescription,
      name,
      osVersionIds,
      publisherId,
      shortDescription,
      status: payloadStatus ? (payloadStatus satisfies OsVersionPublicationStatus) : undefined,
    },
  };
}
